module.exports = __webpack_public_path__ + "img/pic24.c4fe89db.png";